import axios from "axios";
import jwt_decode from "jwt-decode";
import _ from "lodash";
import { handleUserInfo } from "../utils/userResponse";
import { generateSurveyId } from "../utils/userResponse";
import { handleUpdateUserAPI } from "./recommendationService";
/**
 * API calls to profile information of the user.
 */
export const mdmsService: any = async () => {
  let encodedData = localStorage.getItem("okta-token-storage");
  let userConsentFlag = localStorage.getObj("user-consent");
  let encodedData1 = encodedData ? JSON.parse(encodedData) : null;
  generateSurveyId();
  // used to send userInfo
  let userInfoObj: any = {
    accountId: "",
    accountName: "",
    accountSubType: "",
    country: "",
    partyId: "",
    salesPlanAff: "",
    language: "",
    aboNumber: "",
    userEmail: "",
    recoUserId: "",
    userConsent:
      userConsentFlag && userConsentFlag === "accepted" ? true : false,
    pinNumber: "",
  };
  const token =
    (encodedData1 &&
      encodedData1.accessToken &&
      encodedData1.accessToken.accessToken) ||
    "";
  const idToken = encodedData1.idToken;
  let decoded: any = token ? jwt_decode(token) : "";


  const partyId = idToken ? idToken.claims.partyId : ""; //"3744170"; //
  const salesPlanAff = idToken ? idToken.claims.account.sales_plan_aff : ""; //010
  userInfoObj.partyId = partyId;
  userInfoObj.salesPlanAff = salesPlanAff;
  userInfoObj.aboNumber = idToken ? idToken.claims.account.abo : "";
  userInfoObj.userEmail = idToken ? idToken.claims.email : "";

if (!encodedData && (!partyId || !salesPlanAff)) {
  const anonymousUser = {
    ...userInfoObj,
    partyId: "anonymous",
    accountId: "anonymous",
  };

  localStorage.setObj("user-info", anonymousUser);
  return anonymousUser;
}

  if (partyId && salesPlanAff) {
    const AccountUrl = `${process.env.REACT_APP_MDMS_ACCOUNT_BASE_URL}${partyId}/accounts?api_key=${process.env.REACT_APP_API_KEY}&salesPlanAff=${salesPlanAff}`;
    // API call to get account information by party id
    return axios
      .get(AccountUrl, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then(async (res) => {
        // Add data from -- Get MDMS Account by Party
        if (res) {
          userInfoObj.accountId = res.data.amwayAccountList[0].accountId;
          userInfoObj.accountName = res.data.amwayAccountList[0].accountName;
          userInfoObj.accountSubType =
            res.data.amwayAccountList[0].accountSubTypeCd;
          userInfoObj.country = res.data.amwayAccountList[0].cntryCd;
          if (res && res.data && res.data.amwayAccountList) {
            const accountId =
              res && res.data ? res.data.amwayAccountList[0].accountId : "";
            //API call to get party profile of the user
            return axios
              .get(
                `${process.env.REACT_APP_MDMS_PARTY_BASE_URL}${salesPlanAff}-${accountId}/parties/${partyId}/?api_key=${process.env.REACT_APP_API_KEY}`,
                {
                  headers: {
                    Authorization: `Bearer ${token}`,
                  },
                }
              )
              .then(async (res) => {
                // Add data from -- Get MDMS Party Profile
                userInfoObj.givenName =
                  res.data.party.nameList[0].localeName.givenName;
                userInfoObj.language = res?.data?.party?.partyMst?.languageCd;
                let fullLangName = _.includes(
                  res?.data?.party?.partyMst?.languageCd,
                  "-us"
                )
                  ? res?.data?.party?.partyMst?.languageCd
                  : res?.data?.party?.partyMst?.languageCd + "-us";
                userInfoObj.pinNumber = res?.data?.party?.partyMst?.userPin;
                sessionStorage.setItem("languageTypeOfApp", fullLangName);
                userInfoObj.recoUserId = localStorage?.getObj("reco-user-id");
                localStorage.setObj("user-info", userInfoObj);
                let userInfoData = localStorage.getObj("user-info");
                delete userInfoData.pinNumber;
                delete userInfoData.givenName;
                userInfoData = userInfoData;
                const handleUserInfoResult = await handleUserInfo(
                  userInfoData
                ).then(async (resp: any) => {
                  if(resp?.data?.createUser?.userConsent) {
                    localStorage.setObj("user-consent", "accepted");
                  }
                  if(localStorage?.getObj("user-consent") === "accepted" && !resp?.data?.createUser?.userConsent) {
                    await handleUpdateUserAPI(userInfoData)
                  }
                  // if (resp?.data?.updateRecoUserId?.status) {
                  //   if (resp?.data?.updateRecoUserId?.status === 200) {
                  //     return resp;
                  //   }
                  // } else {
                  //   if (resp?.status === 200) {
                  //     return resp;
                  //   }
                  // }
                  return resp;
                });
                return handleUserInfoResult;
              })
              .catch((err: any) => {
                return err;
              });
          }
        } else {
          userInfoObj.accountId = idToken ? idToken.claims.account.abo : "";
          localStorage.setObj("user-info", userInfoObj);
        }
      })
      .catch((err: any) => {
        return err;
      });
  }
};
